import React, { Component } from 'react';

export const withLiveChat = WrappedComponent =>
  class WithLiveChatUI extends Component {
    openLiveChatIncChatWidget = () => {
      if (window.LC_API && window.LC_API.open_chat_window) {
        window.LC_API.open_chat_window();
      }
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          onLiveChatBtnClick={this.openLiveChatIncChatWidget}
        />
      );
    }
  };
